import * as React from "react";

import fetcher, { HTTPMethods } from "../hooks/fetcher";
import useIdentity from "../hooks/useIdentity";
import { logger } from "../util";

const refreshSession = () =>
  fetcher("/api/auth/refresh", { method: HTTPMethods.POST }).catch((error) =>
    logger.error(error),
  );

const UserAuth = () => {
  useIdentity();

  React.useEffect(() => {
    refreshSession();
  }, []);

  return null;
};

export default UserAuth;
